import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Users, Building2, User, Settings } from 'lucide-react';

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Hide navigation on login/registration pages
  const hideNavRoutes = ['/accesso', '/login', '/registrati'];
  const shouldHideNav = hideNavRoutes.some(route => 
    location.pathname === route || location.pathname.startsWith(route + '/')
  );

  if (shouldHideNav) {
    return null;
  }

  const navItems = [
    {
      icon: Home,
      label: 'Dashboard',
      path: '/dashboard'
    },
    {
      icon: Users,
      label: 'Candidati',
      path: '/admin',
      tab: 'candidati'
    },
    {
      icon: Building2,
      label: 'Agenzie',
      path: '/admin',
      tab: 'agenzie'
    },
    {
      icon: User,
      label: 'Profilo',
      path: '/admin',
      tab: 'overview'
    },
    {
      icon: Settings,
      label: 'Impostazioni',
      path: '/admin',
      tab: 'impostazioni'
    }
  ];

  const isActive = (item) => {
    if (item.path === '/dashboard') {
      return location.pathname === '/dashboard';
    }
    
    // Per gli altri tab dell'admin panel, controlliamo sia il path che il tab attivo
    if (location.pathname === '/admin') {
      const urlParams = new URLSearchParams(location.search);
      const currentTab = urlParams.get('tab') || 'overview'; // default tab
      return currentTab === item.tab;
    }
    
    return false;
  };

  const handleNavClick = (item) => {
    if (item.path === '/dashboard') {
      navigate('/dashboard');
    } else {
      // Naviga all'admin panel con il tab specifico
      navigate(`${item.path}?tab=${item.tab}`, { replace: true });
      
      // Forza l'aggiornamento del tab nell'AdminPanel se esiste
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('tabChange', { detail: item.tab }));
      }, 100);
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 md:hidden" 
         style={{ 
           boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.04), 0 -1px 3px rgba(0, 0, 0, 0.06)',
           backdropFilter: 'blur(10px)'
         }}>
      {/* Instagram/LinkedIn inspired clean design */}
      <div className="flex items-center justify-around px-4 py-2" style={{ height: '65px' }}>
        {navItems.map((item, index) => {
          const Icon = item.icon;
          const active = isActive(item);
          
          return (
            <button
              key={index}
              onClick={() => handleNavClick(item)}
              className={`flex flex-col items-center justify-center transition-all duration-200 min-w-0 flex-1 rounded-lg p-1 touch-manipulation ${
                active 
                  ? 'text-blue-700 transform scale-105' 
                  : 'text-gray-400 hover:text-gray-600 active:scale-95'
              }`}
              style={{ 
                minHeight: '50px', 
                minWidth: '50px',
                WebkitTapHighlightColor: 'transparent'
              }}
            >
              <Icon 
                className={`transition-all duration-200 mb-1 ${
                  active ? 'w-5 h-5 text-blue-700' : 'w-5 h-5 text-gray-400'
                }`} 
                strokeWidth={active ? 2.5 : 1.8}
              />
              <span className={`text-xs font-medium leading-tight text-center transition-all duration-200 ${
                active ? 'text-blue-700' : 'text-gray-400'
              }`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MobileBottomNav;